import { apiCallCenter, apiClientAudio } from '@/plugins/axios'

export default {
  getFilas() {
    return apiCallCenter().get('/queue')
  },
  getFila(id) {
    return apiCallCenter().get(`/queue/${id}`)
  },
  getFilaUse(id) {
    return apiCallCenter().get(`/queue/use/${id}`)
  },
  postFila(fila) {
    return apiCallCenter().post('/queue', fila)
  },
  putFila(id, fila) {
    return apiCallCenter().put(`/queue/${id}`, fila)
  },
  deleteFila(id) {
    return apiCallCenter().delete(`/queue/${id}`)
  },
  getAudios() {
    return apiClientAudio().get('/audios/lazy')
  },
  getMusicasEmEspera() {
    return apiClientAudio().get('/musica/lazy')
  },
}
